/** Shared i18n helpers for Credit Builder pages */

export const normalizeStrategyKey = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

/** Translate known enum labels; fall back to raw API/UI value */
export const translateEnum = (t, keyPrefix, value) => {
  if (value === null || value === undefined || value === '') return value;
  const key = `${keyPrefix}.${normalizeStrategyKey(value)}`;
  return t(key, null, value);
};

export const translateReadinessStatus = (t, status, fallbackLabel) => {
  if (!status) return fallbackLabel || '';
  return t(`creditBuilder.cliPlanner.strategyLabels.${status}`, null, fallbackLabel || status);
};

export const translatePlannerBucket = (t, bucketKey, fallbackLabel) => {
  if (!bucketKey) return fallbackLabel || '';
  return t(`creditBuilder.cliPlanner.plannerBuckets.${bucketKey}.label`, null, fallbackLabel || bucketKey);
};

export const translatePlannerBucketDesc = (t, bucketKey, fallbackDesc) => {
  if (!bucketKey) return fallbackDesc || '';
  return t(`creditBuilder.cliPlanner.plannerBuckets.${bucketKey}.description`, null, fallbackDesc || '');
};

export const buildPlanHorizonOptions = (t) => [
  { value: '30', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizon30', null, '30 days'), days: 30 },
  { value: '60', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizon60', null, '60 days'), days: 60 },
  { value: '90', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizon90', null, '90 days'), days: 90 },
  { value: '180', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizon180', null, '180 days'), days: 180 },
  { value: '365', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizon365', null, '365 days'), days: 365 },
  { value: 'follow_bucket', label: t('creditBuilder.cliPlanner.accountCard.script.planHorizonFollowBucket', null, 'Follow Planner Bucket'), days: null },
];

export const buildYesNoUnknownOptions = (t, AC) => [
  { value: 'Yes', label: t(`${AC}.options.yes`, null, 'Yes') },
  { value: 'No', label: t(`${AC}.options.no`, null, 'No') },
  { value: 'Unknown', label: t(`${AC}.options.unknown`, null, 'Unknown') },
];

export const buildMethodOptions = (t, AC) => [
  { value: 'Phone', label: t(`${AC}.script.methodPhone`, null, 'Phone') },
  { value: 'App', label: t(`${AC}.script.methodApp`, null, 'App') },
  { value: 'Secure Message', label: t(`${AC}.script.methodSecureMessage`, null, 'Secure Message') },
  { value: 'Branch', label: t(`${AC}.script.methodBranch`, null, 'Branch') },
];

export const buildPullOptions = (t, AC) => [
  { value: 'Unknown', label: t(`${AC}.script.pullUnknown`, null, 'Unknown') },
  { value: 'Soft', label: t(`${AC}.script.pullSoft`, null, 'Soft') },
  { value: 'Hard', label: t(`${AC}.script.pullHard`, null, 'Hard') },
  { value: 'Mixed', label: t(`${AC}.script.pullMixed`, null, 'Mixed') },
  { value: 'Soft / Mixed', label: t(`${AC}.script.pullSoftMixed`, null, 'Soft / Mixed') },
];

export const buildRiskOptions = (t, AC) => [
  { value: 'Conservative', label: t(`${AC}.script.riskConservative`, null, 'Conservative') },
  { value: 'Balanced', label: t(`${AC}.script.riskBalanced`, null, 'Balanced') },
  { value: 'Stretch', label: t(`${AC}.script.riskStretch`, null, 'Stretch') },
];

export const buildCapacityOptions = (t, AC) => [
  { value: 'Low', label: t(`${AC}.script.capacityLow`, null, 'Low') },
  { value: 'Medium', label: t(`${AC}.script.capacityMedium`, null, 'Medium') },
  { value: 'High', label: t(`${AC}.script.capacityHigh`, null, 'High') },
];

export const buildOutcomeOptions = (t, AC) => [
  { value: 'Pending', label: t(`${AC}.script.outcomePending`, null, 'Pending') },
  { value: 'Approved', label: t(`${AC}.script.outcomeApproved`, null, 'Approved') },
  { value: 'Denied', label: t(`${AC}.script.outcomeDenied`, null, 'Denied') },
];
